import {ref, computed} from "vue";
import {useStore} from "vuex";

import {fetchNUXSettings, updateNUXSettings} from "@songfinch/data-source/nux-settings";

import {getLocalStorage, addLocalStorage} from "@songfinch/utils/src/storage";

import type {NUXType, NUXSettingType, UserType} from "@songfinch/types";

const activeNUXIndex = ref<number>(0);
const acceptanceSettingsArray = ref<string[]>([]);
const activeNUX = ref<NUXType | undefined>();
const listNUX = ref<NUXType[] | undefined>();

export default () => {
    const store = useStore();
    const user = computed<UserType>(() => store.state.auth.user);

    const checkAuthedNUXAcceptanceSettings = async () => {
        if (user.value) {
            const res = await fetchNUXSettings();
            if (res.settings) {
                acceptanceSettingsArray.value = res.settings.reduce((settingArray: string[], setting: NUXSettingType) => {
                    if (setting.displayed) {
                        settingArray.push(setting.name);
                    } 
                    return settingArray;
                }, []);
            }
        } else {
            const anonymousUserNUXSettings = getLocalStorage<string[]>("anonymousUserNUXSettings");
            if (anonymousUserNUXSettings?.length) {
                acceptanceSettingsArray.value = anonymousUserNUXSettings;
            }
        }
        setActiveNUX();
    };

    const updateUserNUXAcceptanceSettings = async () => {
        if (!activeNUX.value) return;
        if (user.value) {
            await updateNUXSettings(activeNUX.value.placementId);
        }
        else {
            const anonymousUserNUXSettings = getLocalStorage<string[]>("anonymousUserNUXSettings") ?? [];
            anonymousUserNUXSettings.push(activeNUX.value?.placementId);
            addLocalStorage("anonymousUserNUXSettings", anonymousUserNUXSettings);
        }
    };


    // injests an object and splits its key value pairs into placementId and text
    // e.g. {actionBar: 'sampleText'} === {placementId: 'actionBar', text: 'sampleText'}
    // placementId will match the parent id we want to attach the NUX to
    // text will be the display text of the NUX
    const initPageNUX = async (pageDataStoryNUX: {[k: string]: string}) => {
        listNUX.value = Object.entries(pageDataStoryNUX).map(([key, value]) => {
            return {placementId: key, text: value};
        });
        await checkAuthedNUXAcceptanceSettings();
    };

    const setActiveNUX = () => {
        if (!listNUX.value) return;
        const filteredList = listNUX.value.filter((nuxItem: NUXType) => {
            return !acceptanceSettingsArray.value.includes(nuxItem.placementId);
        });
        activeNUX.value = filteredList[activeNUXIndex.value] ?? undefined;
    };

    const handleAcceptedNUX = async () => {
        await updateUserNUXAcceptanceSettings();
        activeNUXIndex.value = activeNUXIndex.value + 1;
        setActiveNUX();
    };

    return {
        activeNUX,
        handleAcceptedNUX,
        initPageNUX,
    };
};